<!-- @format -->

<project-detail-tag>
    <style>
        .contents_block .container_progress-info {
            background-color: #F4F4F4;
            border-radius: 6px;
            padding: 8px;
            margin: 16px 0 0;
        }

        /******　公募広告の進捗状況 ******/
        .progress_list {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .progress_list .progress_list-item {
            font-size: 1.3rem;
            margin: 0 24px 0 0;
        }

        .progress_list .progress_list-item:last-child {
            margin: 0;
        }

        .progress_list .progress_list-item .progress_list-item-title {
            font-weight: bold;
        }

        .progress_list .progress_list-item .amount {
            font-size: 1.5rem;
            font-weight: bold;
            color: #E02040;
            margin: 0 8px;
        }

        .contents_table.pay_table tr th.pay_table-cell_date {
            width: 20%;
        }

        .contents_table.pay_table tr th.pay_table-cell_id {
            width: 15%;
        }

        .contents_table.pay_table tr th.pay_table-cell_price {
            width: 15%;
        }

        .contents_table.pay_table tr th.pay_table-cell_settlement {
            width: 20%;
        }

        .contents_table.pay_table tr th.pay_table-cell_detail {
            width: 30%;
        }

        .contents_table.pay_table tr td.pay_table-cell_price {
            color: #E02040;
        }

        .contents_table.pay_table tr td:last-child {
            padding-right: 16px;
        }

        .contents_table.pay-detail_table tr.total {
            background-color: #FFD8EA;
        }

        .contents_table.pay-detail_table tr.total td.pay-detail_table-cell_price_total {
            font-weight: bold;
            font-size: 1.5rem;
        }

        .contents_table.pay-detail_table tr th.pay-detail_table-cell_price_total {
            text-align: right;
            padding-right: 16px;
        }

        .contents_table.pay-detail_table tr td {
            vertical-align: middle;
        }

        .contents_table.pay-detail_table tr td.pay-detail_table-cell_price {
            color: #E02040;
        }

        .contents_table.pay-detail_table tr td:last-child {
            padding-right: 16px;
        }

        .contents_table.pay-detail_table tr td.pay-detail_table-cell_percent {
            color: #E02040;
        }

        .contents_table.pay-detail_table tr td.pay-detail_table-cell_price_total {
            text-align: right;
            padding-right: 16px;
            color: #E02040;
        }

        .pay-detail_table th, .pay-detail_table td {
            padding: 12px 8px;
        }

    </style>
    <div class="container_contents">
        <div class="container_breadcrumb">
            <ul class="breadcrumb">
                <li class="breadcrumb-item"><a class="projects" onclick={(e)=>project(e)}>稼働プロジェクト</a></li>
                <li class="breadcrumb-item"><h1>詳細</h1></li>
            </ul>
        </div><!--/.container_breadcrumb-->

        <div class="contents">
            <ul class="alert_message01 margin-spacing-1_bottom" if={!state.basicinfoFilled}>
                <li class="alert_message01-item "><a
                        href="/info">本人確認書類が未提出です（お仕事の受託やクライアント様との交渉ができません）</a></li>
            </ul><!--/.alert_message-->

            <section class="contents_area" if={'work_type' in detail}>
                <div class="contents_block detail">
                    <div class="container_project-info margin-spacing-1_bottom">
                        <span class="status_label project_status_label-{detail.state} margin-spacing-1_right"></span>
                    </div><!--/.container_project-info-->
                    <ul class="information_list margin-spacing-1_bottom">
                        <li class="information_list-item "><span
                                class="information_list-item-title">プロジェクトID:</span>
                            { project_id }
                        </li>
                        <li class="information_list-item "><span
                                class="information_list-item-title">発注元企業:</span>{detail.client_name}
                        </li>
                    </ul><!--/.information_list-->

                    <ul class="information_list margin-spacing-1_bottom">
                        <li class="information_list-item ">
                            <span class="information_list-item-title">適格請求書発行事業者の登録状況※:</span>
                            <invoice-provider-state-jname-tag
                                    invoice_provider_state={detail.invoice_provider_state_worker}
                            ></invoice-provider-state-jname-tag>
                            { (detail.invoice_provider_state_worker === 20 && (detail.invoice_provider_number_worker)) ? "(" + detail.invoice_provider_number_worker + ")" : ""}
                        </li>
                    </ul>

                    <invoice-provider-state-diff-result
                            style="font-size:1.2rem;margin-bottom:1rem;display:block"
                            invoice_provider_state={detail.invoice_provider_state_worker}
                            invoice_provider_state_now={detail.invoice_provider_state_worker_now}
                    ></invoice-provider-state-diff-result>

                    <h2 class="matter_heading-detail margin-spacing-2_bottom">{detail.title}</h2>

                    <div class="text margin-spacing-2_bottom">
                        <ul>
                            <li><span style="font-weight: bold">仕事内容：</span><span
                                    each={(item,index) in detail.work_type.show_items}>{item.jname}</span></li>
                            <li>
                                <span style="font-weight: bold">コンテンツ形式：</span>
                                <span each={(item,index) in detail.text_content_type.show_items}>{item.group_jname}
									(
									{item.jname}
									{ (item.memo !== "") ? ":" + item.memo : ""}
									)
									{((index + 1) < detail.text_content_type.show_items.length) ? " / " : ""}
								</span>
                            </li>
                        </ul>

                    </div>

                    <p class="text margin-spacing-2_bottom">
						<span each={ (line,index) in detail.description.split("\n") }>
							{line}<br>
						</span>
                    </p>

                    <div class="container_progress-info" if={detail.state >= 400}>
                        <ul class="progress_list">
                            <li class="progress_list-item">
                                <span class="progress_list-item-title">進捗状況</span>
                                （
                                検収待ち：<span
                                    class="amount">{detail.submission_target_summary.count_waiting_inspection}</span>　/　
                                修正依頼：<span
                                    class="amount">{detail.submission_target_summary.count_waiting_re_submit}</span>　/　
                                検収合格：<span class="amount">{detail.submission_target_summary.count_inspected}</span>
                                ）
                            </li>
                            <li class="progress_list-item">
                                <div if={(detail.state >= 400) && (! (detail.state >= 450) && (detail.state <= 499)) }
                                     class="button button-secondary-mini" onclick={(e)=>delivery(e)}>提出物を確認する
                                </div>
                            </li>
                        </ul>

                    </div><!--/.container_progress-info-->

                    <div class="matter-info margin-spacing-2_top">
                        <ul class="matter-info_list margin-spacing-1_bottom" style="display: block">

                            <li class="matter-info_list-item"><span
                                    class="matter-info_list-item-title">掲載予定媒体:</span>
                                <span each={(item,index) in detail.target_medias.show_items}>{item.jname}
								{ (item.memo !== "") ? "(" + item.memo + ")" : ""}
								{((index + 1) < detail.target_medias.show_items.length) ? " / " : ""}
								</span>
                            </li>

                            <li class="matter-info_list-item"><span
                                    class="matter-info_list-item-title">ジャンル・テーマ:</span>
                                <span each={(item,index) in detail.text_content_genres.show_items}>{item.jname}
								{ (item.memo !== "") ? "(" + item.memo + ")" : ""}
								{((index + 1) < detail.text_content_genres.show_items.length) ? " / " : ""}
								</span>
                            </li>

                            <li class="matter-info_list-item"><span
                                    class="matter-info_list-item-title">想定ターゲット:</span>
                                <span each={ (line,index) in detail.target_reader.split("\n") }>{line}<br></span>
                            </li>

                        </ul><!--/.information_list-->
                    </div><!--/.matter-info-->

                    <table class="detail_table">

                        <!-- 作業範囲 -->
                        <tr class="detail_table-row">
                            <th class="detail_table-heading">作業範囲</th>
                            <td class="detail_table-data">
                                <ul class="scope-detail_list">

                                    <li class="scope-detail_list-item"
                                        each={(scope_name,index) in Object.keys(detail.working_scope) }
                                        if={detail.working_scope[scope_name].show_items[0]}>

                                        {detail.working_scope[scope_name].item_jname} :

                                        <span if={scope_name !== "working_scope_image_selection_title"}
                                              each={ (item,item_index) in detail.working_scope[scope_name].show_items}
                                              style="font-weight: normal"
                                        >
                      {item.jname}
                    </span>


                                        <!--
                                        <ul class="scope-detail_sublist" if={scope_name != "working_scope_image_selection_title"}>
                                          <li class="scope-detail_sublist-item" each={ (item,item_index) in detail.working_scope[scope_name].show_items}>
                                            {item.jname}
                                          </li>
                                        </ul>
                                        -->
                                        <ul class="scope-detail_sublist"
                                            if={scope_name == "working_scope_image_selection_title"}>
                                            <li class="scope-detail_sublist-item">
                                                {detail.working_scope[scope_name].show_items[0]["value"]}枚
                                            </li>
                                        </ul>

                                        <div if={scope_name == "working_scope_notation_rule"} style="margin: 1em">
                                            <ul class="scope-detail_sublist">
                                                <li class="scope-detail_sublist-item"
                                                    if={detail.working_scope["working_scope_notation_rule"]["memos"]["working_scope_notation_rule_memo_kanji"] !== ""}>
                                                    表記ルール内容｜漢字 :
                                                    <span style="font-weight: normal">
                          {detail.working_scope["working_scope_notation_rule"]["memos"]["working_scope_notation_rule_memo_kanji"]}
                        </span>

                                                </li>
                                                <li class="scope-detail_sublist-item"
                                                    if={detail.working_scope["working_scope_notation_rule"]["memos"]["working_scope_notation_rule_memo_kana"] !== ""}>
                                                    表記ルール内容｜ひらがな :
                                                    <span style="font-weight: normal">
                          {detail.working_scope["working_scope_notation_rule"]["memos"]["working_scope_notation_rule_memo_kana"]}
                        </span>

                                                </li>
                                                <li class="scope-detail_sublist-item"
                                                    if={detail.working_scope["working_scope_notation_rule"]["memos"]["working_scope_notation_rule_memo_english"] !== ""}>
                                                    表記ルール内容｜英語 :
                                                    <span style="font-weight: normal">
                          {detail.working_scope["working_scope_notation_rule"]["memos"]["working_scope_notation_rule_memo_english"]}
                        </span>

                                                </li>
                                                <li class="scope-detail_sublist-item"
                                                    if={detail.working_scope["working_scope_notation_rule"]["memos"]["working_scope_notation_rule_memo_num"] !== ""}>
                                                    表記ルール内容｜数字 :
                                                    <span style="font-weight: normal">
                          {detail.working_scope["working_scope_notation_rule"]["memos"]["working_scope_notation_rule_memo_num"]}
                        </span>

                                                </li>
                                                <li class="scope-detail_sublist-item"
                                                    if={detail.working_scope["working_scope_notation_rule"]["memos"]["working_scope_notation_rule_memo_symbol"] !== ""}>
                                                    表記ルール内容｜記号 :
                                                    <span style="font-weight: normal">
                          {detail.working_scope["working_scope_notation_rule"]["memos"]["working_scope_notation_rule_memo_symbol"]}
                        </span>

                                                </li>

                                            </ul>

                                        </div>

                                    </li>


                                </ul>
                            </td>
                        </tr>


                        <tr class="detail_table-row" if={detail.working_scope_urls.length > 0}>
                            <th class="detail_table-heading">参考URL</th>
                            <td class="detail_table-data">
                                <ul class="reference_list" each={ url in detail.working_scope_urls }>
                                    <li class="reference_list-item">
                                        <a class="reference_list-item_website" href="{url}" target="_blank">{url}</a>
                                    </li>
                                </ul>
                            </td>
                        </tr>

                        <tr class="detail_table-row" if={detail.working_scope_files.length > 0}>
                            <th class="detail_table-heading">添付ファイル</th>
                            <td class="detail_table-data">
                                <ul class="reference_list" each={ file in detail.working_scope_files }>
                                    <li class="reference_list-item">
                                        <a class="reference_list-item_documents"
                                           onclick={e=>download(file.hash)}>{file.origin_name}</a>
                                    </li>
                                </ul>
                            </td>
                        </tr>


                        <tr class="detail_table-row">
                            <th class="detail_table-heading">補足コメント</th>
                            <td class="detail_table-data">
                                <p class="text" each={ (line,index) in detail.working_scope_memo.split("\n") }>
                                    {line}
                                </p>
                            </td>
                        </tr>

                        <tr class="detail_table-row">
                            <th class="detail_table-heading">依頼したいテキストコンテンツのファイル形式</th>
                            <td class="detail_table-data">

                                <ul class="scope-detail_list">
                                    <li class="scope-detail_list-item"
                                        each={show_item in detail.delivery_file_type.show_items}>
                                        {show_item.jname}
                                    </li>

                                </ul>

                                <p style="font-size: 1.25rem;line-height: 1.25em"
                                   each={ (line,index) in detail.delivery_file_type_memo.split("\n") }>
                                    {line}
                                </p>

                            </td>
                        </tr>


                        <tr class="detail_table-row">
                            <th class="detail_table-heading">制作物の数</th>
                            <td class="detail_table-data">

                                <ul class="scope-detail_list">
                                    <li class="scope-detail_list-item">
                                        {detail.volume}{di.Edilent.cTypeProps(detail.text_content_type.items.group_ids).num}
                                    </li>
                                </ul>
                                <p class="text">
                                    ※分納方式で報酬の支払いを行いますので、複数の制作物依頼でも1納品（検収合格）する毎に報酬が支払われます。</p>

                            </td>
                        </tr>


                        <tr class="detail_table-row">
                            <th class="detail_table-heading">初回提出期限</th>
                            <td class="detail_table-data">

                                <ul class="scope-detail_list">
                                    <li class="scope-detail_list-item"
                                        each={ (delivery_hope_datetimes_item,index) in detail.delivery_hope_datetimes }>
                                        制作物{index + 1}：{delivery_hope_datetimes_item}
                                    </li>
                                </ul>

                            </td>
                        </tr>


                        <tr class="detail_table-row">
                            <th class="detail_table-heading">修正回数上限</th>
                            <td class="detail_table-data">

                                <ul class="scope-detail_list">
                                    <li class="scope-detail_list-item">
                                        {detail.max_retake_count}回
                                    </li>
                                </ul>
                                <p class="text">（目安であり、事情、理由によってはこの限りではありません）</p>

                            </td>
                        </tr>


                        <tr class="detail_table-row"
                            if={!di.Edilent.isNonCharContentType(detail.text_content_type.items.group_ids)}>
                            <th class="detail_table-heading">
                                {di.Edilent.cTypeProps(detail.text_content_type.items.group_ids).title}
                            </th>
                            <td class="detail_table-data">

                                <ul class="scope-detail_list">
                                    <li class="scope-detail_list-item">
                                        <number-format number={detail.char_count_per_post}/>
                                        {di.Edilent.cTypeProps(detail.text_content_type.items.group_ids).unit}
                                    </li>
                                </ul>
                            </td>
                        </tr>

                        <tr class="detail_table-row">
                            <th class="detail_table-heading">1制作物あたりの報酬単価</th>
                            <td class="detail_table-data">

                                <div each={ (reward_unit) in detail.amount_info.reward_units }>


                                    <table class="contents_table pay-detail_table margin-spacing-3_top margin-spacing-3_bottom">
                                        <tbody>
                                        <tr>
                                            <th class="">制作物</th>
                                            <th class="pay-detail_table-cell_reward">①発注⾦額（税抜）</th>
                                            <th class="pay-detail_table-cell_tax_percent">②消費税率</th>
                                            <th class="pay-detail_table-cell_tax">③消費税額</th>
                                            <th class="pay-detail_table-cell_withholding"
                                                if={detail.amount_info.company_type === 2}>④源泉徴収税額
                                            </th>
                                            <th class="pay-detail_table-cell_price_total"
                                                if={detail.amount_info.company_type === 2}>差引請求額（①+③-④）
                                            </th>
                                            <th class="pay-detail_table-cell_price_total"
                                                if={detail.amount_info.company_type === 1}>請求額（①+③）
                                            </th>
                                        </tr>
                                        <tr each={ (item,index) in reward_unit.items }>
                                            <td class="">{index + 1}</td>
                                            <td class="pay-detail_table-cell_reward">
                                                <number-format number={item.unit_price_per_post}/>
                                                円
                                            </td>
                                            <td class="pay-detail_table-cell_tax_percent">{item.tax_rate * 100}%</td>
                                            <td class="pay-detail_table-cell_tax">
                                                <number-format number={item.tax_per_post}/>
                                                円
                                            </td>
                                            <td class="pay-detail_table-cell_withholding"
                                                if={detail.amount_info.company_type === 2}>▲
                                                <number-format number={item.tax_withholding_per_post}/>
                                                円
                                            </td>
                                            <td class="pay-detail_table-cell_price_total">
                                                <number-format number={item.reward_price_per_post}/>
                                                円
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table><!--/.contents_table-->


                                </div>
                                <p>
                                    ＊報酬を分納することによる発生する差額につきましては、初回制作物報酬にて調整となります。</p>
                                <p style="margin-left:1rem">
                                    分納により発生する差額：
                                    <number-format number={detail.amount_info.margin_by_reward_sum}/>
                                    円

                                    {(detail.amount_info.reward_margin_items.length >= 1) ? "(" : ""}
                                    <span each={ (item,index) in detail.amount_info.reward_margin_items}>
									{margin_type_jnames[item.margin_type]}：<number-format number={item.margin_price}/>円
									{(index + 1 < detail.amount_info.reward_margin_items.length) ? "、" : ""}
								</span>
                                    {(detail.amount_info.reward_margin_items.length >= 1) ? ")" : ""}
                                </p>

                            </td>
                        </tr>


                        <tr class="detail_table-row">
                            <th class="detail_table-heading">報酬額（発注金額）の合計</th>
                            <td class="detail_table-data">


                                <table class="contents_table pay-detail_table margin-spacing-3_top margin-spacing-3_bottom">
                                    <tbody>
                                    <tr>
                                        <th class="pay-detail_table-cell_reward">①発注⾦額（税抜）</th>
                                        <th class="pay-detail_table-cell_tax_percent">②消費税率</th>
                                        <th class="pay-detail_table-cell_tax">③消費税額</th>
                                        <th class="pay-detail_table-cell_withholding"
                                            if={detail.amount_info.company_type === 2}>④源泉徴収税額
                                        </th>
                                        <th class="pay-detail_table-cell_price_total"
                                            if={detail.amount_info.company_type === 2}>差引請求額（①+③-④）
                                        </th>
                                        <th class="pay-detail_table-cell_price_total"
                                            if={detail.amount_info.company_type === 1}>請求額（①+③）
                                        </th>
                                    </tr>
                                    <tr class="total">
                                        <td class="pay-detail_table-cell_reward">
                                            <number-format number={detail.amount_info.sub_amount_project}/>
                                            円
                                        </td>
                                        <td class="pay-detail_table-cell_tax_percent">
                                            {detail.amount_info.tax_rate * 100}%
                                        </td>
                                        <td class="pay-detail_table-cell_tax">
                                            <number-format number={detail.amount_info.tax_project}/>
                                            円
                                        </td>
                                        <td class="pay-detail_table-cell_withholding"
                                            if={detail.amount_info.company_type === 2}>▲
                                            <number-format number={detail.amount_info.tax_withholding}/>
                                            円
                                        </td>
                                        <td class="pay-detail_table-cell_price_total">
                                            <number-format number={detail.amount_info.amount_project}/>
                                            円
                                        </td>
                                    </tr>
                                    </tbody>
                                </table><!--/.contents_table-->

                            </td>
                        </tr>
                    </table><!--/.detail_table-->

                    <p class="note" style="white-space: pre-wrap;">
                        ※「分納方式」となりますので、1制作物が「検証合格」になるごとに支払が確定します。
                        　お金の流れに関する詳しい説明はこちらをご確認ください。
                    </p>

                    <p class="project_detail_warning_text_stop"
                       if="{(detail.state === 0) || (detail.state === 101) || ( (detail.state >= 450) && (detail.state <= 499) )}">
                        こちらのプロジェクトは停止・または中止されたため、操作を行うことはできません
                    </p>

                    <div class="wrap_button margin-spacing-3_top">
                        <div
                                class="button button-secondary-large button-border button-chat margin-spacing-1_right"
                                type="button" value="チャットを送る" onclick={(e)=>chat(e)}
                                if={(detail.negotiation_id) || ( (detail.state >= 201) && (! (detail.state >= 450) && (detail.state <= 499)) ) }
                        >
                            チャットを送る
                        </div>
                        <div class="button button-secondary-large button-delivery" type="button" value="納品する"
                             onclick={(e)=>delivery(e)}
                             if={(detail.state >= 400) && (! (detail.state >= 450) && (detail.state <= 499) )}>
                            制作物を提出する
                        </div>
                        <div class="button button-secondary-large button-border" type="button"
                             onclick={(e)=>openNegotiationModal(e)}
                             if={(detail.negotiation_id) && (detail.state === 100  || detail.state === 200) }>
                            再交渉する
                        </div>
                    </div>
                    <div class="wrap_button margin-spacing-1_top"
                         if={detail.negotiation_id && (detail.state === 100  || detail.state === 200)}>
                        <div class="button button-secondary-large button-notice margin-spacing-1_right" type="button"
                             onclick={(e)=>openCancelModal(e)}>
                            辞退する
                        </div>
                        <div class="button button-secondary-large" type="button" onclick={(e)=>openAcceptModal(e)}>
                            この内容で受託する
                        </div>
                    </div>

                    <div class="wrap_button margin-spacing-1_top"
                         if={(! detail.negotiation_id) && (detail.state === 100  || detail.state === 200) }>
                        <p style="color: red;font-weight: bold;font-size: 1.5rem;text-align: center">
                            このプロジェクトはワーカー様の受託意思が確認できず、<br>
                            プロジェクト確定にいたらなかったため、不成立となりました。
                        </p>
                    </div>
                </div><!--/.contents_block-->
            </section><!--/.contents_area-->
        </div><!--/.contents-->

    </div><!--/.container_contents-->
    <cancel-confirm-modal-tag onSubmit={onCancelSubmit} isOpen="{cancelModalIsOpen}"
                              onClose={closeCancelModal}></cancel-confirm-modal-tag>
    <accept-confirm-modal-tag onSubmit={onAcceptSubmit} sentJudge={sentJudge} onOk={onAcceptOk}
                              isOpen="{acceptModalIsOpen}" onClose={closeAcceptModal}></accept-confirm-modal-tag>
    <accept-error-modal-tag isOpen="{errorModalIsOpen}" onClose={closeErrorModal} error-type="{ error.type }"
                            message="{ error.message }"></accept-error-modal-tag>
    <negotiation-confirm-modal-tag onSubmit={onNegotiationSubmit} isOpen="{negotiationModalIsOpen}"
                                   onClose={closeNegotiationModal}></negotiation-confirm-modal-tag>


    <script>
        import di from "dependency-injection";
        import cancelConfirm from "@tags/modal/project/cancel-confirm.riot";
        import acceptConfirm from "@tags/modal/project/accept-confirm.riot";
        import acceptError from "@tags/modal/project/accept-error.riot";
        import negotiationConfirm from "@tags/modal/project/negotiation-confirm.riot";
        import invoiceProviderStateJname from "@tags/parts/info/invoice-provider-state-jname.riot";
        import invoiceProviderStateDiffResult from "@tags/parts/info/invoice-provider-state-diff-result.riot";

        export default {
            di: di,
            components: {
                "cancel-confirm-modal-tag": cancelConfirm,
                "accept-confirm-modal-tag": acceptConfirm,
                "accept-error-modal-tag": acceptError,
                "negotiation-confirm-modal-tag": negotiationConfirm,
                "invoice-provider-state-jname-tag": invoiceProviderStateJname,
                "invoice-provider-state-diff-result": invoiceProviderStateDiffResult
            },
            cancelModalIsOpen: false,
            acceptModalIsOpen: false,
            errorModalIsOpen: false,
            negotiationModalIsOpen: false,
            agreement: false,
            project_id: false,
            sentJudge: false,
            detail: {},
            error: {},
            state: {
                basicinfoFilled: true
            },
            margin_type_jnames: {
                "tax": "消費税",
                "withholding": "源泉徴収額",
            },
            //close series
            closeCancelModal(e) {
                this.cancelModalIsOpen = false;
                this.update()
            },
            openCancelModal(e) {
                this.cancelModalIsOpen = true;
                this.update()
            },
            onCancelSubmit() {
                this.api.request('detail', 'cancel-project', {project_id: this.project_id})
                    .then(data => {
                        this.cancelModalIsOpen = false;
                        this.update();
                        di.router.push(`/project`)
                    })
                    .catch(err => alert(err));
            },
            //accept series
            closeAcceptModal(e) {
                this.acceptModalIsOpen = false;
                this.sentJudge = false;
                this.update();
            },
            closeErrorModal(e) {
                this.errorModalIsOpen = false;
                this.update();
            },
            openAcceptModal(e) {
                this.sentJudge = false;
                this.acceptModalIsOpen = true;
                this.update();
            },
            onAcceptSubmit() {
                this.api.request('detail', 'accept-project', {negotiation_id: this.detail.negotiation_id})
                    .then(data => {

                        this.sentJudge = true;
                        this.update();
                    })
                    .catch(err => {
                        if (err.hasOwnProperty("data") && err.data.hasOwnProperty("type")) {
                            this.acceptModalIsOpen = false;
                            this.errorModalIsOpen = true;
                            this.error = {type: err.data.type, message: err.message};
                            this.update();
                        } else {
                            alert(err);
                        }
                    });
            },
            onAcceptOk() {
                this.sentJudge = false;
                this.acceptModalIsOpen = false;
                this.update();
                this.fetchDetail();
            },
            //negotiation series
            closeNegotiationModal(e) {
                this.negotiationModalIsOpen = false;
                this.update()
            },
            openNegotiationModal(e) {
                this.negotiationModalIsOpen = true;
                this.update()
            },
            onNegotiationSubmit() {
                this.negotiationModalIsOpen = false;
                this.update();
                this.api.request('detail', 'negotiation-project', {negotiation_id: this.detail.negotiation_id})
                    .then(data => this.fetchDetail())
                    .catch(err => alert(err));
            },
            download(hash) {
                this.api.request('detail', 'download', {project_id: this.project_id, hash: hash})
                    .then(data => {
                        const downLoadLink = document.createElement("a");
                        downLoadLink.href = data;
                        downLoadLink.click();
                    });
            },
            project(e) {
                di.router.push(`/project`);
            },
            chat(e) {
                this.api.request('detail', 'open-chat', {id: this.project_id})
                    .then(data => di.router.push(data));
            },
            delivery(e) {
                di.router.push(`/project/delivery/${this.project_id}`);
            },
            reload(data) {
            },
            fetchDetail() {
                this.api.request('detail', 'fetch-detail', {id: this.project_id})
                    .then(data => {
                        this.detail = data;
                        this.update();
                    })
                    .catch(error => {
                        di.toast.push("データの取得に失敗しました", "negative");
                    });
            },
            fetchBasicinfoFilled() {
                di.createApi('menu').request('index', 'check-basic-info-filled')
                    .then(data => this.update({basicinfoFilled: data}));
            },
            onBeforeMount(props, state) {
                if (!props.routeParams[0]) {
                    return;
                }
                //if (location.pathname.match(/agreement$/)) {
                //  this.agreement = true;
                //}
                this.project_id = props.routeParams[0];
                this.api = di.createApi('project');
                this.fetchDetail();
                this.fetchBasicinfoFilled();

            }
        }
    </script>
</project-detail-tag>
